export const availableFontFamilies = [
    'Algerian',
    'Aptos',
    'Arial',
    'Book Antiqua',
    'Bookman Old Style',
    'Calibri',
    'Californian FB',
    'Cambria',
    'Cambria Math',
    'Candara',
    'Century Gothic',
    'Century Schoolbook',
    'Comic Sans MS',
    'Courier New',
    'Dupincel',
    'EB Garamond',
    'Ebrima',
    'Gadugi',
    'Garamond',
    'Georgia',
    'Impact',
    'Lucida Sans Unicode',
    'Montserrat',
    'Nunito',
    'Open Sans',
    'Palatino',
    'Palatino Linotype',
    'Perpetua',
    'Roboto',
    'Segoe Print',
    'Segoe Script',
    'Segoe UI',
    'Song',
    'Source Sans Pro',
    'Symbol',
    'Tahoma',
    'Times New Roman',
    'Trebuchet MS',
    'Tw Cen MT',
    'Ubuntu',
    'Verdana',
    'Wingdings'
];

export default availableFontFamilies;
